import React from 'react';
import CartIcon from '../../../assets/Nocart.png';

const NoCartItem = () => {
  return (
    <div className="  w-full  md:max-w-md min-h-[300px] py-10 bg-white shadow-c-sm  flex flex-col justify-center items-center mx-auto">
      <div>
        <img
          className="w-[200px] h-full object-contain"
          src={CartIcon}
          alt="No Item"
        />
      </div>
      <p className="text-base font-semibold text-primary mt-4">
        Your cart is empty
      </p>
    </div>
  );
};

export default NoCartItem;
